// 简体中文语言包
export default {
  // 通用
  'common.confirm': '确认',
  'common.cancel': '取消',
  'common.submit': '提交',
  'common.save': '保存',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.back': '返回',
  'common.loading': '加载中...',
  'common.noData': '暂无数据',
  'common.success': '操作成功',
  'common.error': '操作失败',
  'common.retry': '重试',
  'common.more': '查看更多',
  'common.language': '语言',
  'common.loginRequired': '请先登录',
  'common.networkError': '网络错误，请稍后重试',
  
  // 登录页面
  'login.title': '登录',
  'login.register': '注册',
  'login.username': '用户名',
  'login.password': '密码',
  'login.loginBtn': '登录',
  'login.registerBtn': '注册',
  'login.forgotPassword': '忘记密码？',
  'login.passwordLogin': '账号密码登录',
  'login.passwordRegister': '账号密码注册',
  'login.loginHint': '请输入您的手机号和密码',
  'login.registerHint': '请输入您的手机号和密码进行注册',
  'login.phonePlaceholder': '请输入手机号',
  'login.passwordPlaceholder': '请输入密码',
  'login.loggingIn': '登录中...',
  'login.registering': '注册中...',
  'login.hasAccount': '已有账号？',
  'login.noAccount': '还没有账号？',
  'login.goLogin': '立即登录',
  'login.goRegister': '立即注册',
  'login.loginAgreement': '登录即表示您同意相关服务协议和隐私政策',
  'login.registerAgreement': '注册即表示您同意相关服务协议和隐私政策',
  'login.contactService': '如有问题，请联系客服：{tel}',
  'login.phoneRequired': '请输入手机号',
  'login.phoneInvalid': '请输入正确的手机号',
  'login.passwordRequired': '请输入密码',
  'login.passwordMinLength': '密码至少6位',
  'login.loginSuccess': '登录成功',
  'login.registerSuccess': '注册成功',
  'login.loginFailed': '登录失败，请稍后重试',
  'login.registerFailed': '注册失败，请稍后重试',
  'login.networkError': '网络错误，请检查网络连接',
  'login.codeSent': '验证码已发送',
  'login.sendCodeFailed': '发送验证码失败',
  'login.codeRequired': '请输入验证码',
  'login.codeLogin': '验证码登录',
  'login.codeLoginHint': '请输入手机号和验证码',
  'login.codePlaceholder': '请输入验证码',
  'login.sending': '发送中...',
  'login.sendCode': '发送验证码',
  'login.usePassword': '使用密码登录',
  'login.goPassword': '密码登录',
  'login.goCode': '验证码登录',
  'login.areaCode.china': '+86',
  'login.areaCode.usa': '+1',
  'login.areaCode.uk': '+44',
  'login.areaCode.india': '+91',
  'login.areaCode.singapore': '+65',
  'login.areaCode.hongkong': '+852',
  'login.areaCode.taiwan': '+886',
  'login.areaCode.japan': '+81',
  'login.areaCode.korea': '+82',
  'login.areaCode.malaysia': '+60',
  'login.areaCode.thailand': '+66',
  'login.areaCode.vietnam': '+84',
  'login.areaCode.indonesia': '+62',
  'login.areaCode.philippines': '+63',
  'login.areaCode.russia': '+7',
  'login.areaCode.germany': '+49',
  'login.areaCode.france': '+33',
  'login.areaCode.italy': '+39',
  'login.areaCode.spain': '+34',
  'login.areaCode.netherlands': '+31',
  'login.areaCode.sweden': '+46',
  'login.areaCode.norway': '+47',
  'login.areaCode.denmark': '+45',
  'login.areaCode.brazil': '+55',
  'login.areaCode.mexico': '+52',
  'login.areaCode.australia': '+61',
  'login.areaCode.newzealand': '+64',
  'login.areaCode.saudiarabia': '+966',
  'login.areaCode.uae': '+971',
  'login.areaCode.qatar': '+974',
  'login.areaCode.kuwait': '+965',
  'login.areaCode.bahrain': '+973',
  'login.areaCode.oman': '+968',
  'country.china': '中国',
  'country.usa': '美国',
  'country.uk': '英国',
  'country.india': '印度',
  'country.singapore': '新加坡',
  'country.hongkong': '香港',
  'country.taiwan': '台湾',
  'country.japan': '日本',
  'country.korea': '韩国',
  'country.malaysia': '马来西亚',
  'country.thailand': '泰国',
  'country.vietnam': '越南',
  'country.indonesia': '印尼',
  'country.philippines': '菲律宾',
  'country.russia': '俄罗斯',
  'country.germany': '德国',
  'country.france': '法国',
  'country.italy': '意大利',
  'country.spain': '西班牙',
  'country.netherlands': '荷兰',
  'country.sweden': '瑞典',
  'country.norway': '挪威',
  'country.denmark': '丹麦',
  'country.brazil': '巴西',
  'country.mexico': '墨西哥',
  'country.australia': '澳大利亚',
  'country.newzealand': '新西兰',
  'country.saudiarabia': '沙特阿拉伯',
  'country.uae': '阿联酋',
  'country.qatar': '卡塔尔',
  'country.kuwait': '科威特',
  'country.bahrain': '巴林',
  'country.oman': '阿曼',
  
  // 示例：首页
  'home.welcome': '欢迎',
  'home.title': '首页',
  'home.pageTitle': '首页',
  'home.loginRequired': '请先登录',
  'home.orderHistory': '跳转到订单历史',
  'home.customerService': '跳转到客服中心',
  'home.logoutSuccess': '退出成功',
  'home.greeting': '你好，{name}师傅',
  'home.defaultDriver': '司机',
  'home.onlineStatus': '在线接单中',
  'home.completedOrders': '今日完单',
  'home.todayIncome': '今日收入',
  'home.pendingOrders': '待处理',
  'home.quickFunctions': '快捷功能',
  'home.selectService': '选择需要的服务',
  'home.orderHall': '抢单大厅',
  'home.realTimeOrders': '实时订单推送',
  'home.phoneOrders': '电话订单',
  'home.appointmentManagement': '预约订单管理',
  'home.myWallet': '我的钱包',
  'home.incomeWithdraw': '收入与提现',
  'home.orderRecords': '订单记录',
  'home.recordManagement': '接单记录管理',
  'home.contactService': '如有问题，请联系客服：{tel}',
  
  // 订单卡片
  'orderCard.status.cancelled': '已取消',
  'orderCard.status.calling': '呼叫中',
  'orderCard.status.pickingUp': '接驾中',
  'orderCard.status.arrivedPickup': '司机到达上车点',
  'orderCard.status.passengerBoarded': '乘客上车',
  'orderCard.status.completed': '已完成',
  'orderCard.status.driverCollected': '司机已收款',
  'orderCard.status.unknown': '未知状态',
  
  'orderCard.payment.paid': '已支付',
  'orderCard.payment.unpaid': '未支付',
  
  'orderCard.label.departureTime': '用车时间',
  'orderCard.label.flightInfo': '航班信息',
  'orderCard.label.departure': '出发地',
  'orderCard.label.destination': '目的地',
  'orderCard.label.phone': '联系电话',
  'orderCard.label.remark': '乘客备注',
  'orderCard.label.amount': '订单金额',
  'orderCard.label.paymentStatus': '支付状态',
  
  'orderCard.remark.adults': '{count}位成人',
  'orderCard.remark.children': '{count}位儿童',
  'orderCard.remark.childSeats': '{count}个儿童座椅',
  'orderCard.remark.luggage': '{count}件行李',
  
  'orderCard.action.grabOrder': '抢单',
  'orderCard.action.contactPassenger': '联系乘客',
  'orderCard.action.arrivedPickup': '到达上车点',
  'orderCard.action.passengerBoarded': '乘客上车',
  'orderCard.action.orderEnd': '订单结束',
  
  // 接送机模块 - 通用
  'airportTransfer.error.fetchFailed': '获取数据失败，请检查网络',
  'airportTransfer.error.unknown': '未知错误',
  
  // 接送机模块 - 列表
  'airportTransfer.list.loadingMore': '加载更多数据中...',
  'airportTransfer.list.noMore': '没有更多数据了',
  
  // 接送机模块 - 下拉刷新
  'airportTransfer.pull.activate': '松开立即刷新',
  'airportTransfer.pull.deactivate': '下拉可以刷新',
  'airportTransfer.pull.release': '加载中...',
  'airportTransfer.pull.finish': '刷新完成',
  
  // 接送机模块 - 首页
  'airportTransfer.index.title': '接送机包车服务',
  'airportTransfer.index.subtitle': '快速接单，轻松赚钱',
  'airportTransfer.index.hallTitle': '抢单大厅',
  'airportTransfer.index.hallDesc': '查看可抢订单，快速接单',
  'airportTransfer.index.recordTitle': '接单记录',
  'airportTransfer.index.recordDesc': '管理我的订单，更新状态',
  'airportTransfer.index.tips': '温馨提示：及时更新订单状态，提升服务质量',
  
  // 接送机模块 - 抢单大厅
  'airportTransfer.hall.grabbing': '抢单中...',
  'airportTransfer.hall.grabSuccess': '抢单成功',
  'airportTransfer.hall.grabFailed': '抢单失败',
  'airportTransfer.hall.grabError': '抢单出错，请稍后重试',
  'airportTransfer.hall.emptyText': '暂无可抢订单',
  'airportTransfer.hall.emptyTips': '订单会实时更新，请耐心等待',
  
  // 接送机模块 - 接单记录
  'airportTransfer.record.update': '更新',
  'airportTransfer.record.processing': '处理中...',
  'airportTransfer.record.updateFailed': '更新失败',
  'airportTransfer.record.updateError': '更新状态出错，请稍后重试',
  'airportTransfer.record.emptyText': '暂无接单记录',
  'airportTransfer.record.emptyTips': '快去抢单大厅接单吧',
  
  // 在此处添加更多翻译...

  // 聊天页面
  'chat.title': '与尾号{passengerPhoneSuffix}乘客沟通',
  'chat.close': '关闭',
  'chat.loadingMore': '加载更多...',
  'chat.inputPlaceholder': '请输入消息...',
  'chat.send': '发送',
  'chat.endedTip': '订单对话已结束，无法发送消息',
  'chat.unread': '未读',
  'chat.sending': '⏳',
  'chat.failed': '×',
  'chat.sendFailed': '发送失败',
  'chat.networkError': '网络错误',
  'chat.uploadFailed': '上传失败',
  'chat.loadFailed': '加载失败',

  // 消息中心
  'messageCenter.title': '消息中心',
  'messageCenter.loginRequired': '请先登录',
  'messageCenter.fetchFailed': '获取消息列表失败',
  'messageCenter.networkError': '网络错误，请重试',
  'messageCenter.noMessages': '暂无消息',
  'messageCenter.loading': '加载中...',
  'messageCenter.loadMore': '点击加载更多',
  'messageCenter.orderType.express': '快车',
  'messageCenter.orderType.carpool': '顺风车',
  'messageCenter.orderType.airport': '接送机',
  'messageCenter.orderType.unknown': '未知',
  'messageCenter.time.justNow': '刚刚',
  'messageCenter.time.minutesAgo': '{count}分钟前',
  'messageCenter.time.hoursAgo': '{count}小时前',
  'messageCenter.imageMessage': '[图片]',

  // 钱包页面
  'wallet.pageTitle': '司机钱包',
  'wallet.accountBalance': '账户余额',
  'wallet.fullTimeDriver': '全职司机',
  'wallet.availableBalance': '可提现',
  'wallet.frozenBalance': '已冻结',
  'wallet.nextFreeBalance': '下次预计解冻',
  'wallet.withdraw': '提现',
  'wallet.withdrawBtn': '提现',
  'wallet.billDetails': '账单明细',
  'wallet.income': '收入',
  'wallet.expenditure': '支出',
  'wallet.noIncomeRecords': '暂无收入记录',
  'wallet.noExpenditureRecords': '暂无支出记录',
  'wallet.loadMore': '加载更多',
  'wallet.loading': '加载中...',
  'wallet.refreshActivate': '松开立即刷新',
  'wallet.refreshDeactivate': '下拉可以刷新',
  'wallet.refreshRelease': '加载中...',
  'wallet.refreshFinish': '刷新完成',
  'wallet.withdrawModalTitle': '提现',
  'wallet.withdrawAmountPlaceholder': '请输入提现金额',
  'wallet.availableAmountLabel': '可提现金额：',
  'wallet.alipayAccountPlaceholder': '请输入支付宝账号（邮箱或手机号）',
  'wallet.realNamePlaceholder': '请输入真实姓名',
  'wallet.cancel': '取消',
  'wallet.confirmWithdraw': '确认提现',
  'wallet.withdrawing': '提现中...',
  'wallet.withdrawSuccess': '提现申请成功，请等待处理',
  'wallet.withdrawFailed': '提现失败',
  'wallet.amountRequired': '请输入有效的提现金额',
  'wallet.amountMin': '提现金额不能少于1元',
  'wallet.amountExceed': '提现金额不能超过可提现余额',
  'wallet.accountRequired': '请输入支付宝账号',
  'wallet.accountInvalid': '请输入有效的支付宝账号（邮箱或手机号）',
  'wallet.nameRequired': '请输入真实姓名',
  'wallet.nameMin': '姓名至少2个字符',
  'wallet.nameMax': '姓名不能超过20个字符',
  'wallet.nameInvalid': '请输入有效的姓名',
  'wallet.amountValid': '金额有效',
  'wallet.accountValid': '账号格式正确',
  'wallet.nameValid': '姓名格式正确',
  'wallet.noWithdrawableBalance': '当前可提现金额为0，无法提现',
  'wallet.loginExpired': '登录已过期，请重新登录',
  'wallet.getBalanceFailed': '获取账户余额失败',
  'wallet.getBillsFailed': '获取账单流水失败',
  'wallet.refreshFailed': '刷新失败',
  'wallet.networkError': '网络错误',
  'wallet.unknownError': '未知错误',
  'wallet.receivedFare': '收到车费',
  'wallet.refund': '退款',
  'wallet.withdrawToAlipay': '提现至支付宝账户',
  'wallet.receivedReward': '收到任务奖励',
  'wallet.other': '其他',

  // 电话订单页面
  'callOrder.tab.pending': '待服务',
  'callOrder.tab.finished': '已结束',
  'callOrder.dateFilter.all': '全部',
  'callOrder.dateFilter.today': '今日',
  'callOrder.dateFilter.tomorrow': '明日',
  'callOrder.dateFilter.recent3': '近3日',
  'callOrder.dateFilter.more': '更多日期',
  'callOrder.empty': '暂无订单',
  'callOrder.label.amount': '订单金额',
  'callOrder.action.contactPassenger': '联系乘客',
  'callOrder.action.playVoice': '播放录音',
  'callOrder.message.processing': '处理中...',
  'callOrder.message.updateSuccess': '更新成功',
  'callOrder.message.updateFailed': '更新失败',
  'callOrder.message.updateError': '更新状态出错，请稍后重试',
  'callOrder.voice.playFailed': '语音播放失败',
  'callOrder.voice.noVoice': '暂无语音信息',
  'callOrder.action.arrivedPickup': '到达上车点',
  'callOrder.action.passengerBoarded': '乘客上车',
  'callOrder.action.orderEnd': '订单结束',
  'callOrder.action.update': '更新',
  'callOrder.label.flight': '航班',
  'callOrder.label.phone': '电话',
  'callOrder.detail.loading': '加载中...',
  'callOrder.detail.orderNotFound': '订单不存在',
  'callOrder.detail.fetchFailed': '获取数据失败，请检查网络',
  'callOrder.detail.orderInfoMissing': '订单信息不存在',
  'callOrder.detail.noPickupInfo': '暂无上车点信息',
  'callOrder.detail.noDestinationInfo': '暂无目的地信息',
  'callOrder.detail.voicePlayFailed': '语音播放失败',
  'callOrder.detail.noVoiceInfo': '暂无语音信息',
  'callOrder.detail.processing': '处理中...',
  'callOrder.detail.operationSuccess': '操作成功',
  'callOrder.detail.updateFailed': '更新失败',
  'callOrder.detail.updateError': '更新状态出错，请稍后重试',
  'callOrder.detail.invalidFeeAmount': '请输入有效的车费金额',
  'callOrder.detail.confirmNoCash': '确认未收现金，向乘客发起线上收款？',
  'callOrder.detail.paymentInitiated': '已向乘客发起收款',
  'callOrder.detail.submitFailed': '提交失败',
  'callOrder.detail.submitError': '提交费用出错，请稍后重试',
  'callOrder.detail.confirmCashReceived': '确认已现金收款？',
  'callOrder.detail.orderCompleted': '订单已完成',
  'callOrder.detail.orderIdCopied': '订单号已复制',
  'callOrder.detail.confirm': '确认',
  'callOrder.detail.cancel': '取消',
  'callOrder.detail.arrivedPickupConfirm': '确认已到达乘客上车点？',
  'callOrder.detail.passengerBoardedConfirm': '确认乘客已上车，开始计价？',
  'callOrder.detail.hint': '提示',
  'callOrder.detail.navigation': '导航',
  'callOrder.detail.contactPassenger': '联系乘客',
  'callOrder.detail.replayVoice': '重播语音',
  'callOrder.detail.slideArrivePickup': '滑动到达乘客上车点',
  'callOrder.detail.slidePassengerBoarded': '滑动确认乘客已上车',
  'callOrder.detail.slideEndTrip': '滑动确认行程结束',
  'callOrder.detail.slideOperation': '滑动操作',
  'callOrder.detail.operationSuccessful': '操作成功',
  'callOrder.detail.mapLoading': '地图加载中...',
  'callOrder.detail.mapLoadingHint': '如长时间未显示，请检查网络连接',
  'callOrder.detail.mapLoadFailed': '地图加载失败',
  'callOrder.detail.startPoint': '起点',
  'callOrder.detail.endPoint': '终点',
  'callOrder.detail.paymentWarning': '请让乘客在车内完成支付，避免造成损失',
  'callOrder.detail.fee': '车费',
  'callOrder.detail.enterFee': '请输入车费',
  'callOrder.detail.yuan': '元',
  'callOrder.detail.feeConfirmationNote': '车费确认后不可改',
  'callOrder.detail.noCashPayment': '未收现金，向乘客发起线上收款',
  'callOrder.detail.cashReceived': '已现金收款',
  'callOrder.detail.orderNumber': '订单号：',
  'callOrder.detail.copy': '复制',
  'callOrder.detail.completed': '已完成',

  // 免佣卡
  'freeCard.title': '免佣卡',
  'freeCard.detailTitle': '免佣卡详情',
  'freeCard.myTitle': '已购买列表',
  'freeCard.todayReward': '今日奖励活动',
  'freeCard.viewPurchased': '查看已购买',
  'freeCard.buyModal.title': '购买免佣卡',
  'freeCard.buyModal.walletPay': '钱包余额支付',
  'freeCard.buyModal.walletBalance': '（钱包余额：{balance}元）',
  'freeCard.buyModal.insufficientBalance': '余额不足，您可先跑单待钱包余额充足再来购买',
  'freeCard.buyModal.buyNow': '立即购买',
  'freeCard.buyModal.paying': '支付中...',
  'freeCard.buyModal.paySuccess': '支付成功',
  'freeCard.card.name': '免佣卡-{name}',
  'freeCard.card.sellEndDate': '售卖截止日期：{date}',
  'freeCard.card.cardId': '免佣卡ID：{id}',
  'freeCard.card.freeDate': '免佣日期',
  'freeCard.card.freeTimeSlot': '免佣时段：{slot}',
  'freeCard.card.remaining': '仅剩{remaining}/{total}',
  'freeCard.card.price': '￥{price}',
  'freeCard.card.yuan': '元',
  'freeCard.status.purchased': '已购买',
  'freeCard.status.pending': '待开售',
  'freeCard.status.ended': '已结束',
  'freeCard.status.cancelled': '已取消',
  'freeCard.detail.purchaseTimeLeft': '购买时间仅剩',
  'freeCard.detail.days': '天',
  'freeCard.detail.hours': '时',
  'freeCard.detail.minutes': '分',
  'freeCard.detail.seconds': '秒',
  'freeCard.detail.validTimeLeft': '距离失效还剩',
  'freeCard.detail.usageInstructions': '使用须知',
  'freeCard.empty': '暂无数据',
  'freeCard.channelDetailTitle': '免佣卡详情',
  'freeCard.card.city': '适用城市',
  'freeCard.card.timeSlot': '免佣时段',
  'freeCard.paySuccess.title': '购买成功',
  'freeCard.paySuccess.desc': '您已成功购买免佣卡',
  'freeCard.paySuccess.tips': '请在有效期内使用',
  'freeCard.buyModal.selectPayMethod': '请选择支付方式',
  'freeCard.buyModal.driverWallet': '司机钱包',
  'freeCard.buyModal.wechatPay': '微信支付',
  'freeCard.buyModal.balance': '余额：¥{balance}',
  'freeCard.buyModal.insufficientWalletBalance': '钱包余额不足',
  'freeCard.buyModal.checkingCondition': '正在检查购买条件...',
  'freeCard.buyModal.notEligible': '您暂不符合购买条件',
  'freeCard.driverInfo.title': '司机信息',
  'freeCard.driverInfo.name': '司机姓名',
  'freeCard.driverInfo.phone': '手机号码',
  'freeCard.driverInfo.vehicleNo': '车牌号',
  'freeCard.driverInfo.switchAccount': '切换账号',

  // 邀请页面
  'invite.pageTitle': '邀请好友成为司机',
  'invite.recordTitle': '邀请记录',
  'invite.viewDetail': '查看详情',
  'invite.inviteCount': '邀请人数',
  'invite.receivedReward': '获得奖励',
  'invite.personUnit': '人',
  'invite.yuanUnit': '元',
  'invite.videoTip': '如何邀请好友？点击查看视频教学',
  'invite.inviteNow': '立即邀请',

  // 邀请记录页面
  'inviteInfo.pageTitle': '邀请记录',
  'inviteInfo.recordAndReward': '邀请记录和我的奖励',
  'inviteInfo.noReward': '+ 0元',

  // 扬招单页面
  'beckonOrder.pageTitle': '扬招单',
  'beckonOrder.status.idle': '等待乘客',
  'beckonOrder.status.boarded': '乘客已上车',
  'beckonOrder.status.completed': '乘客已下车',
  'beckonOrder.label.driverInfo': '司机信息',
  'beckonOrder.label.onTime': '上车时间',
  'beckonOrder.label.startAddress': '上车定位',
  'beckonOrder.label.offTime': '下车时间',
  'beckonOrder.label.endAddress': '下车定位',
  'beckonOrder.placeholder.selectTime': '请选择时间',
  'beckonOrder.placeholder.searchAddress': '请搜索地址',
  'beckonOrder.placeholder.notDropped': '未下车',
  'beckonOrder.placeholder.notLocated': '未定位',
  'beckonOrder.action.boarded': '乘客已上车',
  'beckonOrder.action.dropped': '乘客已下车',
  'beckonOrder.action.newOrder': '新建扬招单',
  'beckonOrder.loading': '处理中...',
  'beckonOrder.success.boarded': '上车信息已记录',
  'beckonOrder.success.completed': '订单已完成',
  'beckonOrder.error.startAddressRequired': '请填写上车地址',
  'beckonOrder.error.onTimeRequired': '请选择上车时间',
  'beckonOrder.error.endAddressRequired': '请填写下车地址',
  'beckonOrder.error.endTimeRequired': '请选择下车时间',
  'beckonOrder.error.createFailed': '创建扬招单失败',
  'beckonOrder.error.completeFailed': '完成订单失败',
  'beckonOrder.error.locateFailed': '定位失败，请重试',
  'beckonOrder.action.locate': '点击定位',
  'beckonOrder.locating': '定位中...',
  'beckonOrder.locateSuccess': '定位成功',

  // 首页
  'home.beckonOrder': '扬招单',
  'home.beckonOrderDesc': '线下扬招订单',

}
